<template>
  <div
    ref="checkboxes"
    class="checkboxes"
  >
    <div
      v-for="(label, index) in labels"
      :key="index"
    >
      <checkbox-element
        :class="label.key"
        :label="label.title"
        :name="label.key"
        :is-checked="isChecked(label.key)"
        @update="onCheck($event, label.key)"
      />
    </div>

    <div class="label-disclaimer">
      {{ $t('searchForm.originDestin.labelDisclaimer') }}
    </div>
  </div>
</template>

<script>
  import CheckboxElement from 'components/Elements/Checkbox.vue'

  const events = {
    UPDATE: 'update'
  }

  export default {
    components: {
      CheckboxElement
    },
    props: {
      labels: {
        type: Array,
        required: true
      },
      selected: {
        type: String,
        required: true
      }
    },
    methods: {
      isChecked(key) {
        return this.selected === key
      },
      onCheck(checked, name) {
        if (checked) {
          this.$emit(events.UPDATE, name)

          return
        }

        this.$emit(events.UPDATE, '')
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .checkboxes {
    width: 100%;
    margin: 24px 0;

    .grey-check-wrap {
      margin-bottom: 16px;

      &.label_on_sale {
        ::v-deep span div {
          border-radius: 4px;
          font-weight: 700;
          padding: 0 9px;
          background-color: rgba(237, 19, 19, 0.05);
          color: #d40808;
        }
      }
    }

    ::v-deep input:focus {
      + .checkbox-label:before {
        border-color: $blue-medium;
      }
    }
  }

  .label-disclaimer {
    color: #9b9b9b;
    font-size: 11px;
  }
</style>
